// Bundle dependencies

import NSNotes from "./NSNotes";

module.exports = NSNotes;


// Initialize on document ready


document.addEventListener("DOMContentLoaded", function () {
  NSNotes.init();
});
